<div class="editor">
    <div class="editor_typeahead">
      <input type="number" [(ngModel)]="amount" class="price_input"/>
    </div>
    <div class="editor_action" (click)="save()">
        save
    </div>
  </div>
